import { render, staticRenderFns } from "./nxMobileTab.vue?vue&type=template&id=78dffc40&scoped=true&"
import script from "./nxMobileTab.vue?vue&type=script&lang=js&"
export * from "./nxMobileTab.vue?vue&type=script&lang=js&"
import style0 from "./nxMobileTab.vue?vue&type=style&index=0&id=78dffc40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dffc40",
  null
  
)

export default component.exports